import React, { useCallback, useState } from 'react';

import { CollapseContent } from './CollapseContent';
import { CollapseTrigger } from './CollapseTrigger';
import { CollapseChevron } from './CollapseChevron';
import { CollapseProvider } from './context';

export default function Collapse({ isDefaultOpen = false, children = null }) {
  const [isOpen, setIsOpen] = useState(isDefaultOpen);

  const onToggle = useCallback(() => setIsOpen((open) => !open), []);

  return (
    <CollapseProvider value={{ isOpen, onToggle }}>{children}</CollapseProvider>
  );
}

Collapse.Trigger = CollapseTrigger;
Collapse.Content = CollapseContent;
Collapse.Chevron = CollapseChevron;
